<template>
  <div class="content-wrapper">
    <vs-row class="my-4">
      <vs-col vs-lg="8" vs-sm="12">
        <vs-button :to="addEvent" color="primary" type="filled"
          >Add New</vs-button
        >
      </vs-col>
      <vs-col vs-lg="4" vs-sm="12">
        <div style="float: right">
          <vs-input
            id="search"
            class="inputx"
            placeholder="Search..."
            v-model="search"
            v-on:input="debounceInput"
          />
        </div>
      </vs-col>
    </vs-row>
    <vx-card>
      <b-table
        ref="table"
        style="min-height: 600px"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :selectable="true"
        :select-mode="`multi`"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="columns"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height: 600px">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>

        <template v-slot:cell(privacy)="data">
          <div style="width:100px;">
            <vs-select
              class="selectExample"
              style="width:100%;"
              v-model="data.item.privacy"
              @change="onStatusChanged(data.item)"
            >
              <vs-select-item
                :key="c"
                :value="choice.value"
                :text="choice.text"
                v-for="(choice, c) in privacyList"
              />
            </vs-select>
          </div>
        </template>

        <template v-slot:cell(pro_name)="data">
          <strong>{{ data.item.pro_name }}</strong>
          <div class="text-grey mt-2">
            <i class="fas fa-map-marker-alt"></i>
            {{ data.item.venue }}
          </div>
        </template>

        <template v-slot:cell(date)="data">
          <strong>{{ data.item.date }}</strong>
        </template>

        <template v-slot:cell(action)="data">
          <vs-button @click="open(data.item)" color="primary" type="flat"
            >View</vs-button
          >
          <vs-button @click="duplicate(data.item)" color="dark" type="flat"
            >Duplicate</vs-button
          >
        </template>
      </b-table>
    </vx-card>
  </div>
</template>
<script>
import Service from "@/services";

export default {
  components: {},
  data: () => ({
    columns: [
      { label: "ID", key: "event_id", sortable: false },

      {
        label: "Event Name",
        key: "pro_name",
        sortable: false,
        tdClass: "width-450"
      },
      { label: "Date", key: "date", sortable: false },
      {
        label: "Event Privacy",
        key: "privacy",
        sortable: false
      },
      { label: "", key: "action", sortable: false }
    ],
    privacyList: [
      { text: "Public", value: "public" },
      { text: "Unlisted", value: "unlisted" },
      { text: "Invite Only", value: "invite-only" }
    ],
    search: "",
    filter: "",
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    isBusy: false,
    currentPage: 1,
    perPage: 30,
    totalRows: 0,
    selected: [],
    filterOn: [],
    pageOptions: [2, 5, 10, 15, 30, 50],
    addEvent: null
  }),
  mounted() {
    window.addEventListener("keydown", e => {
      if (this.remarkDialog == false) {
        if (!event.target.matches('[id="search"]')) {
          //backspace
          if (e.which == 27 || e.which == 8) {
            let s = this.search.substring(0, this.search.length - 1);
            this.search = s;
          } else if (
            e.ctrlKey ||
            e.altKey ||
            e.shiftKey ||
            e.which == 9 ||
            e.which == 91 ||
            (e.which >= 112 && e.which <= 123)
          ) {
          } else {
            this.search += String.fromCharCode(e.keyCode);
          }
          return;
        }
      }
    });
  },
  created() {
    const data = {
      s: this.$route.query.s,
      e: this.$route.query.e
    }
    this.addEvent = `events/add?s=${data.s}&e=${data.e}`
  },
  methods: {
    debounceInput: _.debounce(function(e) {
      this.filter = e;
      this.search = e;
    }, 500),
    checkSearchStr: _.debounce(function(val) {
      this.filter = val;
      this.$refs.table.refresh();
    }, 500),
    onStatusChanged: _.debounce(function(e) {
      let data = {
        e: e.e,
        privacy: e.privacy
        // publish_status: e.publish_status,
        // listing_status: e.listing_status,
        // featured_status: e.featured_status
      };

      this.$vs.loading();

      Service.Event.update(data).then(res => {
        if (res.success) {
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success"
          });
        }

        this.$vs.loading.close();
      });
    }, 500),
    dataProvider(ctx, callback) {
      setTimeout(() => {
        this.isBusy = true;
        let data = {
          e: this.$route.query.e,
          s: this.$route.query.s
        };

        let params = Object.keys(data)
          .map(key => key + "=" + data[key])
          .join("&");

        params =
          params +
          "&" +
          Object.keys(ctx)
            .map(key => key + "=" + ctx[key])
            .join("&");

        Service.Event.my(params)
          .then(res => {
            this.isBusy = false;
            this.totalRows = res.data.total;
            this.from = res.data.from;
            this.to = res.data.to;
            this.data = res.data.rows;
            this.log = res.log;
            this.lagacy_query = res.lagacy_query;

            callback(this.data);
          })
          .catch(error => {
            console.log(error);
            // Here we could override the busy state, setting isBusy to false
            // this.isBusy = false
            // Returning an empty array, allows table to correctly handle
            // internal busy state in case of error
            //return [];
            callback([]);
          });
        return null;
      }, 1800);
    },
    open(item) {
      this.$router.push("/events/" + item.e + "/view");
    },
    duplicate(item) {
      this.$router.push("/events/add?clone=" + item.e);
    }
  }
};
</script>
<style>
.width-250 {
  width: 250px;
}
.width-300 {
  width: 300px;
}
.width-450 {
  width: 450px;
}
</style>
